import axios from '../axiosConfig';
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

const fetchSales = async (data) => {
  // Check network connectivity
  console.log('🌐 Network online status:', navigator.onLine);
  if (!navigator.onLine) {
    console.warn('⚠️ Network is offline, returning fallback data');
    return {
      status: 200,
      data: {
        data: {
          total_sell_amount: 0,
          total_orders: 0,
          growth_rate: 0,
          top_sales_by_location: [],
          top_categories: [],
          revenue: { data: [] },
          recent_orders: [],
          best_selling_products: [],
          best_selling_brands: []
        }
      },
      message: 'Using fallback data - Network is offline'
    };
  }

  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }

  try {
    console.log('🔍 Fetching sales data with params:', data);
    console.log('🌐 API Base URL:', baseURL);
    console.log('🔑 Headers:', headers);
    console.log('🔗 Full URL will be:', `${baseURL}/sales/stats?start_date=${data.start_date}&end_date=${data.end_date}`);
    
    // Check if we have a valid auth token
    const authToken = sessionStorage.getItem("authToken");
    console.log('🔐 Auth Token exists:', !!authToken);
    console.log('🔐 Auth Token length:', authToken ? authToken.length : 0);
    
    // Test basic connectivity first
    console.log('🧪 Testing basic connectivity...');
    try {
      const testResponse = await axios.get('/health', { timeout: 5000 });
      console.log('✅ Basic connectivity test passed:', testResponse.status);
    } catch (testError) {
      console.warn('⚠️ Basic connectivity test failed:', testError.message);
    }
    
    const response = await axios.get(`/dashboard/sales/stats?start_date=${data.start_date}&end_date=${data.end_date}`, { headers });
    console.log('✅ Sales data response:', response);
    return response;
  } catch (error) {
    console.error('❌ Error fetching sales data:', error);
    
    // Log detailed error information
    console.group('🔍 Detailed Error Information');
    console.error('Error Message:', error.message);
    console.error('Error Code:', error.code);
    console.error('Error Name:', error.name);
    console.error('Response Status:', error.response?.status);
    console.error('Response Status Text:', error.response?.statusText);
    console.error('Response Data:', error.response?.data);
    console.error('Request URL:', error.config?.url);
    console.error('Request Method:', error.config?.method);
    console.error('Request Base URL:', error.config?.baseURL);
    console.error('Request Headers:', error.config?.headers);
    console.error('Full Error Object:', error);
    console.groupEnd();
    
    // Handle network errors
    if (error.code === 'ERR_NETWORK' || error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
      console.warn('🌐 Network error detected, returning fallback data');
      return {
        status: 200,
        data: {
          data: {
            total_sell_amount: 0,
            total_orders: 0,
            growth_rate: 0,
            top_sales_by_location: [],
            top_categories: [],
            revenue: { data: [] },
            recent_orders: [],
            best_selling_products: [],
            best_selling_brands: []
          }
        },
        message: 'Using fallback data - Network connection issue'
      };
    }
    
    // Handle 404 errors
    if (error.response?.status === 404) {
      console.warn('🔍 API endpoint not found, returning fallback data');
      return {
        status: 200,
        data: {
          data: {
            total_sell_amount: 0,
            total_orders: 0,
            growth_rate: 0,
            top_sales_by_location: [],
            top_categories: [],
            revenue: { data: [] },
            recent_orders: [],
            best_selling_products: [],
            best_selling_brands: []
          }
        },
        message: 'Using fallback data - API endpoint not available'
      };
    }
    
    // Handle other errors
    return {
      status: error.response?.status || 500,
      data: {
        data: {
          total_sell_amount: 0,
          total_orders: 0,
          growth_rate: 0,
          top_sales_by_location: [],
          top_categories: [],
          revenue: { data: [] },
          recent_orders: [],
          best_selling_products: [],
          best_selling_brands: []
        }
      },
      message: error.response?.data?.message || error.message || 'Using fallback data - API server unavailable'
    };
  }
}; 
const fetchRecentActivity = async () => {

  var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
  if (! axios.defaults.headers.common["Authorization"]){
    headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
  }
  
  try {
    const response = await axios.get('/orders/list', { headers });
    return response; 
  } catch (error) {
    console.error('Error fetching recent activity:', error);
    
    // Check for specific error types
    if (error.code === 'NETWORK_ERROR' || error.message.includes('fetch')) {
      return {
        status: 0,
        data: null,
        message: 'Network error: Unable to connect to the server. Please check your internet connection.'
      };
    }
    
    if (error.response?.status === 404) {
      return {
        status: 404,
        data: null,
        message: 'API endpoint not found. The recent activity API may not be configured properly.'
      };
    }
    
    // Return a structured error response instead of null
    return {
      status: error.response?.status || 500,
      data: null,
      message: error.response?.data?.message || error.message || 'Failed to fetch recent activity. The API server may be unavailable.'
    };
  }
}
export { fetchSales, fetchRecentActivity, baseURL };